import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');

export const getters = {
  getLineFields() {
    return { model: 'plans_line', 
            label: 'Lines',
            fields: [
              { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
              { key: 'description', label: 'Description', type: 'textfield', sortable: true, required: false },
              { key: 'source', label: 'Source', type: 'model', 
                model_source: 'Sources', model_route: 'management/masters/sources', 
                sortable: true, required: true, formatter: (value, key, item) => {
                return item.source.instance__name || item.source.name
              }}
            ]}
  },
}

export const actions = {
  async fetchLines(context, query = '') {
    return axios
      .get(`${serverUrl}/api/masters/lines/${query}`)
      .then((response) => {
        return response.data;
      })
  },

  async createLines(context, { payload }) {
    return axios
      .post(`${serverUrl}/api/masters/lines/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async updateLines(context, { payload }) {
    return axios
      .patch(`${serverUrl}/api/masters/lines/${payload.id}/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async deleteLines(context, { id }) {
    return axios
      .delete(`${serverUrl}/api/masters/lines/${id}/`)
      .then((response) => {
        return response.data;
      })
  },

  fetchLinesOptions(context, query) {
    query = query || ''
    return axios.options(`${serverUrl}/api/masters/lines/${query}`).then((response) => {
      return response.data
    })
  },
}